import { Component, computed, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { RouterModule } from '@angular/router';
import { MDIconComponent, MDHeaderComponent } from '@melodic-ui/components';
import { PageHeaderComponent } from '@lb/components/page-header/page-header.component';
import { ComponentLoaderService } from '@melodic-ui/services';
import { ChatStateService } from '@lb/state/chat-state.service';
import { ConversationListComponent } from './components/conversation-list/conversation-list.component';
import { ChatMessageAreaComponent } from '@lb/components/chat-message-area/chat-message-area.component';
import { AuthenticationService } from '@lb/auth/services/authentication.service';
import { ResponsiveLayoutComponent } from '@lb/components/page-templates/responsive-layout/responsive-layout.component';

@Component({
	selector: 'lrnr-chat',
	standalone: true,
	imports: [RouterModule, ResponsiveLayoutComponent, ConversationListComponent, ChatMessageAreaComponent, MDIconComponent, MDHeaderComponent],
	templateUrl: './chat.component.html',
	styleUrl: './chat.component.scss'
})
export class ChatComponent implements OnInit, OnDestroy {
	private _componentLoaderService = inject(ComponentLoaderService);
	private _chatStateService = inject(ChatStateService);
	private _authService = inject(AuthenticationService);

	@ViewChild(ResponsiveLayoutComponent) responsiveLayout!: ResponsiveLayoutComponent;
	// State from service
	threads = this._chatStateService.threads;
	activeThread = this._chatStateService.activeThread;
	messages = this._chatStateService.messages;
	loading = this._chatStateService.loading;

	userInitials = computed(() => {
		const user = this._authService.getUser();
		if (!user?.firstName || !user?.lastName) return 'U';
		return `${user.firstName[0]}${user.lastName[0]}`.toUpperCase();
	});

	ngOnInit(): void {
		// Set page header
		this._componentLoaderService.getContainer('banner-main-content').component.set(PageHeaderComponent);
		this._componentLoaderService.getContainer('banner-main-content').inputs.set({
			pageTitle: 'Chat Assistant'
		});

		// Load threads
		this._chatStateService.loadThreads();
	}

	ngOnDestroy(): void {
		this._componentLoaderService.getContainer('banner-main-content').component.set(null);
	}

	selectThread(threadId: string): void {
		this._chatStateService.setActiveThread(threadId);
		this.responsiveLayout?.closeSlideout();
	}

	createNewThread(): void {
		this._chatStateService.createNewThread();
	}

	toggleMobileMenu(): void {
		this.responsiveLayout?.toggleSlideout();
	}

	sendMessage(message: string): void {
		this._chatStateService.sendMessage(message);
	}
}
